import React from 'react';
import { css } from 'aphrodite';
import { AppButton } from '../common/components/AppButton';
import { CustomQRCodeGenStyles } from '../styles/CustomStyles';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { Helper } from '../common/helpers/Helper';
import { IconButton, Tooltip } from '@material-ui/core';
const QrStyles = CustomQRCodeGenStyles;

function QrDialogContent({page, utmCampaign, qrDataUrl, onUtmChange, onDownload, buildFullLink, utmOptions, qrShowAdvanced, onToggleAdvanced,
  inputLabel = 'UTM Campaign',
  inputHint = '(optional)',
  inputValue,
  onInputChange,
  showPrimaryInput = true,
  showAdvanced = true,
  showCopyLink = false,
  onCopyLink,
}) 
{
  const primaryValue = inputValue !== undefined ? inputValue : utmCampaign
  const fullLink = buildFullLink(page, primaryValue, utmOptions);

  return (
    <div className={css(QrStyles.dialogWrapper)}>
      <div className={css(QrStyles.dialogBody)}>
        <div className={css(QrStyles.dialogLeft)}>
          <div className={css(QrStyles.formSection)}>
            <p className={css(QrStyles.label)}>Full Link</p>
            <div className={css(QrStyles.formControl)}>
              <div className={css(QrStyles.copyLinkControl)}>
                <input
                  disabled
                  value={fullLink}
                  className={css(QrStyles.readOnlyInput, showCopyLink && QrStyles.readOnlyInputWithCopy)}
                />
                {showCopyLink && (
                  <Tooltip title="Copy link" placement="top">
                    <span>
                      <IconButton
                        disableRipple
                        size="small"
                        onClick={() => {
                          Helper.copyToClipboard(fullLink)
                          if(onCopyLink) {
                            onCopyLink()
                          }
                        }}
                      disabled={!fullLink}
                    >
                      <FileCopyOutlinedIcon style={{ fontSize: 20,alignItems:'center',paddingRight:10}} />
                    </IconButton>
                  </span>
                </Tooltip>
                )}
              </div>
            </div>
          </div>

         {showPrimaryInput && (
          <div className={css(QrStyles.formSection)}>
            <p className={css(QrStyles.label)}>
                {inputLabel}
                {inputHint && (
                <span style={{ fontWeight: 400, color: '#999', marginLeft: 4 }}>
                  {inputHint}
                </span>
              )}
            </p>
            <div className={css(QrStyles.formControl)}>
              <input
                type="text"
                value={primaryValue || ''}
                onChange={e => {
                  if (onInputChange) {
                    onInputChange(e.target.value)
                  } else if (onUtmChange) {
                    onUtmChange('utmCampaign', e.target.value)
                  }
                }}
                className={css(QrStyles.textInputStyles)}
              />
            </div>
          </div>
        )}
      </div>
        <div className={css(QrStyles.dialogRight)}>
          <div className={css(QrStyles.qrPreviewBox)}>
            {qrDataUrl
              ? <img src={qrDataUrl} alt="QR Code" className={css(QrStyles.qrImage)} />
              : <span className={css(QrStyles.qrPlaceholder)}>QR preview will appear here</span>
            }
          </div>
        </div>
      </div>
      {showAdvanced && (
      <Accordion
        elevation={0}
        expanded={qrShowAdvanced}
        onChange={onToggleAdvanced}
        className={css(QrStyles.accordionWrapper)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={css(QrStyles.accordionIcon)} />}
          className={css(QrStyles.accordionSummary)}
          style={{ borderTop: 'none' }}
        >
          <Typography className={css(QrStyles.advancedTitle)}>Advanced</Typography>
        </AccordionSummary>
        <AccordionDetails className={css(QrStyles.accordionDetails)}>
          <div style={{ width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {[
              { label: 'UTM Source',  field: 'utm_source'  },
              { label: 'UTM Medium',  field: 'utm_medium'  },
              { label: 'UTM Content', field: 'utm_content' },
              { label: 'UTM Term',    field: 'utm_term'    },
              { label: 'UTM ID',      field: 'utm_id'      },
            ].map(({ label, field }) => (
              <div key={field} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <p className={css(QrStyles.label)}>{label}</p>
                <input
                  type="text"
                  value={utmOptions[field]}
                  onChange={e => onUtmChange(field, e.target.value)}
                  className={css(QrStyles.textInputStyles)}
                  style={{ height: 40, boxSizing: 'border-box' }}
                />
              </div>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <AppButton
          buttonText="Download QR Code"
          onClick={onDownload}
          disabled={!qrDataUrl}
          buttonStyle={QrStyles.downloadBtn}
        />
      </div>
    </div>
  );
}

export default QrDialogContent;